export default () => {
    type Els = {
        consumer: HTMLInputElement | null;
        business: HTMLInputElement | null;
        company: HTMLElement | null;
        vat: HTMLElement | null;
        country: HTMLSelectElement | null;
    };

    const getEls = (): Els => ({
        consumer: document.getElementById('billing_type_personal') as HTMLInputElement | null,
        business: document.getElementById('billing_type_business') as HTMLInputElement | null,
        company: document.getElementById('billing_company_field') as HTMLElement | null,
        vat: document.getElementById('webreact-btw-number_field') as HTMLElement | null,
        country: document.getElementById('billing_country') as HTMLSelectElement | null,
    });

    const updateVisibility = () => {
        const { consumer, business, company, vat, country } = getEls();
        if (!company || !vat) return;

        const isBusiness = !!business?.checked;
        const countryCode = (country?.value || '').toUpperCase();
        const isNL = countryCode === 'NL';

        company.style.display = isBusiness ? 'block' : 'none';

        vat.style.display = isBusiness && !isNL ? 'block' : 'none';
    };

    document.addEventListener('change', (e) => {
        const t = e.target as HTMLElement | null;
        if (!t) return;
        const id = (t as HTMLInputElement).id;
        if (
            id === 'billing_country' ||
            id === 'billing_type_personal' ||
            id === 'billing_type_business'
        ) {
            updateVisibility();
        }
    });

    const w = window as any;
    if (w?.jQuery) {
        const $ = w.jQuery;
        $(document.body).on('updated_checkout country_to_state_changed', updateVisibility);
        $(document).on('select2:select', '#billing_country', updateVisibility);
    }

    const mo = new MutationObserver(() => updateVisibility());
    mo.observe(document.body, { childList: true, subtree: true });

    updateVisibility();
};
